import React from 'react';

export default function ConfirmationModal({
  show,
  title,
  message,
  onClose,
  onConfirm,
  confirmText = 'Si, confirmar',
  cancelText = 'No, cancelar',
  confirmDisabled = false,
}) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/45 px-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-2xl">
        <h3 className="mb-3 text-lg font-semibold text-slate-900">{title}</h3>
        <p className="mb-6 text-sm text-slate-600">{message}</p>
        <div className="flex justify-center gap-3">
          <button
            onClick={onClose}
            className="rounded-xl bg-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-300"
            type="button"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className="rounded-xl bg-red-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60"
            type="button"
            disabled={confirmDisabled}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
